import Vue from 'vue'
import Router from 'vue-router'
import routes from '../libs/router'

Vue.use(Router)

export default new Router({
  routes
})
